<template>
  <div :class="$style.sectionFeatures">
    <div class="container section">
      <div v-for="(item, index) in list" class="feature-container" :class="{ 'row-reverse': index % 2 !== 0 }" :key="index">
        <div v-if="index % 2 !== 0" class="feature-content wow animate__animated animate__fadeInRight">
          <div class="content-offset">
            <p class="sub-title">{{ item.subTitle }}</p>
            <h2 class="title" v-html="item.title"></h2>
            <div class="content" v-html="item.content"></div>
          </div>
        </div>
        <div v-else class="feature-content wow animate__animated animate__fadeInLeft">
          <div class="content-offset">
            <p class="sub-title">{{ item.subTitle }}</p>
            <h2 class="title" v-html="item.title"></h2>
            <div class="content" v-html="item.content"></div>
          </div>
        </div>

        <div v-if="index % 2 !== 0" class="feature-img wow animate__animated animate__fadeInLeft">
          <img :src="item.img" alt="" />
        </div>
        <div v-else class="feature-img  wow animate__animated animate__fadeInRight">
          <img :src="item.img" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'animate.css'
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      list: [
        {
          title: '專屬優惠，<br />投放給對的人！',
          subTitle: 'Coupons',
          content:
            '<p>愛美訂的「優惠券」功能，讓您針對不同服務項目設定折扣優惠及使用條件，還可對指定客戶進行優惠設定，將行銷效益極大化。<br>讓優惠不再無的放矢，還能提高客戶參與度，有助業績成長！</p>',
          img: require('@assets/dingbeauty-images/advanced-plan/system_01@1.png'),
        },
        {
          title: '線上金流付款',
          subTitle: 'Online Payment',
          content:
            '<p>預約下單後，客戶會收到系統發送的付款通知簡訊。透過安全的第三方金流驗證機制，提供線上信用卡和ATM虛擬帳號等多種付款方式，讓客戶提前完成付款，提升有效預約，大幅降低未出席的狀況。</p>',
          img: require('@assets/dingbeauty-images/advanced-plan/system_02@1.png'),
        },
        {
          title: '服務空間管理',
          subTitle: 'Scheduleing ',
          content: '<p>讓您可以根據各項服務的需求，靈活調配分店內的空間和人員，實現店面使用效率最大化，同步提升您的運營便利性，也能使客戶擁有更好的預約服務體驗。</p>',
          img: require('@assets/dingbeauty-images/advanced-plan/system_03@1.png'),
        },
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()
    })
  },
}
</script>

<style lang="scss" module>
$color-primary: #e3c192;

.sectionFeatures {
  :global {
    .feature-container {
      display: block;
      margin-bottom: 120px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .feature-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: url('~@assets/dingbeauty-images/home/background01@2.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      text-align: center;
      margin-bottom: 1rem;

      .sub-title {
        color: $color-primary;
        font-size: 16px;
      }

      .title {
        font-size: 30px;
        margin-bottom: 2rem;
      }

      .content {
        color: #545662;
        font-size: 14px;
      }
    }

    .start-text {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: $color-primary;

      &::before {
        content: '';
        background-image: url('~@assets/dingbeauty-images/basic-plan/icon_shiny2.svg');
        background-size: cover;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
}

@media (min-width: 1200px) {
  .sectionFeatures {
    :global {
      .feature-container {
        display: flex;
        gap: 100px;
        margin-bottom: 160px;

        &.row-reverse {
          flex-direction: row-reverse;
        }
      }

      .feature-content {
        min-width: 600px;
        max-width: 600px;
        margin-bottom: 0;
        .content-offset {
          max-width: 400px;
          margin-left: 100px;
        }

        .sub-title {
          color: $color-primary;
          font-size: 22px;
          text-align: left;
        }

        .title {
          font-size: 40px;
          margin-bottom: 4rem;
          text-align: left;
        }

        .content {
          text-align: left;
          font-size: 16px;
        }
      }

      .feature-img {
        img {
          min-width: 960px;
          max-width: 960px;
          border-radius: 10px;
          box-shadow: 0 5px 20px rgba(40, 45, 78, 0.2);
        }
      }

      .start-text {
        font-size: 24px;

        &::before {
          content: '';
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
</style>
